import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import classes from "./auth-service-tools606.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { AccordionChevron } from "./auth-service-tools313.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getSize, getFontSize } from "./auth-service-tools185.js";
const defaultProps = {
  nextDisabled: false,
  previousDisabled: false,
  hasNextLevel: true,
  withNext: true,
  withPrevious: true
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    calendarHeader: {
      "--dch-control-size": getSize(size, "dch-control-size"),
      "--dch-fz": getFontSize(size)
    }
  };
});
const CalendarHeader = factory((_props, ref) => {
  const props = useProps("CalendarHeader", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    label,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    __staticSelector,
    __preventFocus,
    __stopPropagation,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "CalendarHeader",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "calendarHeader"
  });
  const preventFocus = __preventFocus ? event => event.preventDefault() : void 0;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...getStyles("calendarHeader"),
    ref,
    ...others,
    children: [withPrevious && /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, { ...getStyles("calendarHeaderControl"),
      "data-direction": "previous",
      "aria-label": previousLabel,
      onClick: onPrevious,
      unstyled,
      onMouseDown: preventFocus,
      disabled: previousDisabled,
      "data-disabled": previousDisabled || void 0,
      tabIndex: __preventFocus || previousDisabled ? -1 : 0,
      "data-mantine-stop-propagation": __stopPropagation || void 0,
      children: previousIcon || /* @__PURE__ */jsxRuntimeExports.jsx(AccordionChevron, { ...getStyles("calendarHeaderControlIcon"),
        "data-direction": "previous",
        size: "45%"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, {
      component: hasNextLevel ? "button" : "div",
      ...getStyles("calendarHeaderLevel"),
      onClick: hasNextLevel ? onLevelClick : void 0,
      unstyled,
      onMouseDown: hasNextLevel ? preventFocus : void 0,
      disabled: !hasNextLevel,
      "data-static": !hasNextLevel || void 0,
      "aria-label": levelControlAriaLabel,
      tabIndex: __preventFocus || !hasNextLevel ? -1 : 0,
      "data-mantine-stop-propagation": __stopPropagation || void 0,
      children: label
    }), withNext && /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, { ...getStyles("calendarHeaderControl"),
      "data-direction": "next",
      "aria-label": nextLabel,
      onClick: onNext,
      unstyled,
      onMouseDown: preventFocus,
      disabled: nextDisabled,
      "data-disabled": nextDisabled || void 0,
      tabIndex: __preventFocus || nextDisabled ? -1 : 0,
      "data-mantine-stop-propagation": __stopPropagation || void 0,
      children: nextIcon || /* @__PURE__ */jsxRuntimeExports.jsx(AccordionChevron, { ...getStyles("calendarHeaderControlIcon"),
        "data-direction": "next",
        size: "45%"
      })
    })]
  });
});
CalendarHeader.classes = classes;
CalendarHeader.displayName = "@mantine/dates/CalendarHeader";
export { CalendarHeader };